import React, { useEffect, useState } from 'react';
import db from './firebase';
import { useParams } from 'react-router-dom';

function Redirect() {
  const { slug } = useParams();
  const [urls, setUrls] = useState([]);
  const [redirecting, setRedirecting] = useState(true);

  useEffect(() => {
    let query = db.collection('urls').where('slug', '==', slug);
    query.onSnapshot((data) => {
      if (data.empty) {
        alert('URL not found');
      }
      let finalData = data.docs[0].data();
      setUrls([finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url].map(url => encodeURIComponent(url)));
    });
  }, [slug]);

  useEffect(() => {
    if (urls.length > 0) {
      let randomIndex = Math.floor(Math.random() * urls.length);
      let redirectUrl = `vnd.youtube://youtube.com/redirect?event=comments&redir_token=QUFFLUhqbUdyVnZZUUhTbEo4WEd5RDNCSnZBZE1mQUIwZ3xBQ3Jtc0tsTVhabWwtLUg1dlZoU0NYM291LU5EMUNlRGhFV1p6d003dVJyTFNkSGllU3I5empMUlZkQ1MzX3EtMkR6cnltZ1hYemg5VkZNU3hBSnNlVW1GTUI2LUxMZVFZcUJWY0NZbFZuYjVTWFgySFJ4ejktdw&q=${urls[randomIndex]}&html_redirect=1`;
      window.location.href = redirectUrl;
    }
  }, [urls]);

  return (
    <div className="container text-center">
      {redirecting && <p> </p>}
    </div>
  );
}

export default Redirect;
